import { Link } from "react-router-dom";
import { useApp } from "../../common/contexts/AppContext";
import BaseContainerWrapper from "../../common/components/BaseContainerWrapper";
import useIncidents from "../../common/hooks/pages/useIncidents";
import useMaintenance from "../../common/hooks/pages/useMaintenance";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import ListIncidents from "../components/ListIncidents";
import ApiValidate from "../../common/components/ApiValidate";
import { useState, useEffect } from "react";
import CompletedIncidents from "../components/CompletedIncidents";
import OpenMaintenances from "../components/OpenMaintenances";

function ListIncident() {
  const { isOwner } = useApp();
  const [openTab, setOpenTab] = useState(1);

  const {
    getIncidents,
    getIncidentStatusTypes,
    deleteIncident,
    getOpenMaintenances,
  } = useIncidents();

  const { deleteMaintenance } = useMaintenance();

  const { toast } = usePopup();

  const queryClient = useQueryClient();

  const { data, isError, isLoading } = useQuery({
    retry: false,
    queryKey: "getIncidents",
    queryFn: getIncidents,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting incidents!";
      toast(message, "error");
    },
  });

  const { data: maintenanceData } = useQuery({
    retry: false,
    queryKey: "getOpenMaintenances",
    queryFn: getOpenMaintenances,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting maintenances!";

      toast(message, "error");
    },
  });

  const { data: statusTypesData } = useQuery({
    retry: false,
    queryKey: "getIncidentStatusTypes",
    queryFn: getIncidentStatusTypes,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting incidents status types!";

      toast(message, "error");
    },
  });

  const { mutate: deleteIncidentMutate } = useMutation({
    mutationFn: deleteIncident,
    onSuccess: (res) => {
      const { message } = res?.data || {};
      toast(message, "success");
      queryClient.refetchQueries("getIncidents");
    },
  });

  const { mutate: deleteMaintenanceMutate } = useMutation({
    mutationFn: deleteMaintenance,
    onSuccess: (res) => {
      const { message } = res?.data || {};
      toast(message, "success");
      queryClient.refetchQueries("getOpenMaintenances");
    },
  });

  const deleteHandler = (event) => {
    const incident = event;
    deleteIncidentMutate({
      id: incident,
    });
  };

  const deleteMaintenanceHandler = (event) => {
    const incident = event;
    deleteMaintenanceMutate(incident);
  };

  const { incidents } = data?.data || {};

  const { incidentStatusTypes } = statusTypesData?.data || {};

  const { maintenances } = maintenanceData?.data || {};

  return (
    <BaseContainerWrapper>
      <div className="flex justify-between items-center pb-8 border-b">
        <div className="text-2xl font-bold">Incidents</div>
        {openTab === 3 ? (
          isOwner ? (
            <Link
              to="/createMaintainance"
              className="rounded-md common_bg text-white px-4 py-2 nav_link-500 transition ease-in-out duration-300"
            >
              Schedule Maintenance
            </Link>
          ) : null
        ) : isOwner ? (
          <Link
            to="/createIncident"
            className="rounded-md common_bg text-white px-4 py-2 nav_link-500 transition ease-in-out duration-300"
          >
            Add Incident
          </Link>
        ) : null}
      </div>

      <div className="flex flex-wrap">
        <div className="w-full">
          <ul
            className="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
            role="tablist"
          >
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                  (openTab === 1
                    ? "text-green-600 bg-gray-200"
                    : "text-gray-600 bg-white")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(1);
                }}
                data-toggle="tab"
                href="#link1"
                role="tablist"
              >
                <i className="fas fa-space-shuttle text-base mr-1"></i>
                Open
              </a>
            </li>
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                  (openTab === 2
                    ? "text-green-600 bg-gray-200"
                    : "text-gray-600 bg-white")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(2);
                }}
                data-toggle="tab"
                href="#link2"
                role="tablist"
              >
                <i className="fas fa-docs text-base mr-1"></i> Incidents
              </a>
            </li>
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                  (openTab === 3
                    ? "text-green-600 bg-gray-200"
                    : "text-gray-600 bg-white")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(3);
                }}
                data-toggle="tab"
                href="#link3"
                role="tablist"
              >
                <i className="fas fa-docs text-base mr-1"></i> Maintenance
              </a>
            </li>
          </ul>
          <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 rounded">
            <div className="px-4 py-5 flex-auto">
              <div className="tab-content tab-space">
                <div className={openTab === 1 ? "block" : "hidden"} id="link1">
                  {incidents?.length ? (
                    <ListIncidents
                      incidents={incidents}
                      incidentStatusTypes={incidentStatusTypes}
                      onDelete={deleteHandler}
                    />
                  ) : (
                    <div className="mt-6 text-gray-500">
                      Open Incidents not found
                    </div>
                  )}
                </div>
                <div className={openTab === 2 ? "block" : "hidden"} id="link2">
                  {incidents?.length ? (
                    <CompletedIncidents
                      incidents={incidents}
                      incidentStatusTypes={incidentStatusTypes}
                      onDelete={deleteHandler}
                    />
                  ) : (
                    <div className="mt-6 text-gray-500">
                      Resolved Incidents not found
                    </div>
                  )}
                </div>
                <div className={openTab === 3 ? "block" : "hidden"} id="link3">
                  {maintenances?.length ? (
                    <OpenMaintenances
                      incidents={maintenances}
                      incidentStatusTypes={incidentStatusTypes}
                      onMaintenanceDelete={deleteMaintenanceHandler}
                    />
                  ) : (
                    <div className="mt-6 text-gray-500">
                      Maintenance not found
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseContainerWrapper>
  );
}

export default ListIncident;
